export default __webpack_public_path__ + "static/media/logoError.813401d4.png";